import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_3: FaireProductEntity = {
  token: "sweet-wink-3",
  type: "product",
  name: "Raspberry Confetti Short Sleeve Tutu Dress - Kids Birthday",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/31e736d7c89b1cc1946f3517233c793109d391d91bc925b900990a116b43a6e4.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1199,1199,x0,y0,safe&width=720",
  priceDollars: 20,
  msrpDollars: 40,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
